import React from "react";
import AddIcon from "@mui/icons-material/Add";
import DeployCache, {
  isShowCache,
} from "src/components/deployCache/DeployCache";
import { useState } from "react";
import { CACHE_RELEASE_GROUP } from "src/constants/actionCache";
import ShowCacheReleaseGroup from "../ShowCache/ShowCacheReleaseGroup";
import { allowedToCreateEntity } from "src/constants/role";
import useAuth from "src/hooks/useAuth";
import { path } from "src/constants/path";
import { Link } from "react-router-dom";
import Controls from "src/components/form/controls/Controls";

const ReleaseGroupControlPanel = ({
  children,
  currentActionCache,
  permissionsAccessControl,
  page,
  limit,
}) => {
  const { auth } = useAuth();
  const [disableButton, setDisableButton] = useState(false);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>{children}</div>
      <div>
        <DeployCache
          title="Cache Release Group"
          isShowButton={isShowCache(currentActionCache, CACHE_RELEASE_GROUP)}
        >
          <ShowCacheReleaseGroup
            disableButton={disableButton}
            setDisableButton={setDisableButton}
          />
        </DeployCache>

        {allowedToCreateEntity(auth?.permissions, permissionsAccessControl) && (
          <Link
            to={{
              pathname: `${path.releaseGroup}/add`,
              state: { page: page, limit },
            }}
          >
            <Controls.Button
              text="Add New"
              variant="outlined"
              startIcon={<AddIcon />}
            />
          </Link>
        )}
      </div>
    </div>
  );
};

export default ReleaseGroupControlPanel;
